import { Button } from 'antd'
import { MoonOutlined, SunOutlined } from '@ant-design/icons'
import { useThemeStore } from '@stores/themeStore'
import './styles.less'

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeStore()

  return (
    <Button
      type="text"
      icon={theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
      onClick={toggleTheme}
      className="theme-toggle"
      title={theme === 'light' ? 'Chuyển sang Dark mode' : 'Chuyển sang Light mode'}
    />
  )
}


